var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0208 11.578L14.8762 14.4327L13.9328 15.376L11.0782 12.5207C10.016 13.3722 8.69483 13.8353 7.3335 13.8333C4.0215 13.8333 1.3335 11.1453 1.3335 7.83334C1.3335 4.52134 4.0215 1.83334 7.3335 1.83334C10.6455 1.83334 13.3335 4.52134 13.3335 7.83334C13.3354 9.19468 12.8723 10.5158 12.0208 11.578ZM10.6835 11.0833C11.5296 10.2133 12.0021 9.04696 12.0002 7.83334C12.0002 5.25468 9.9115 3.16668 7.3335 3.16668C4.75483 3.16668 2.66683 5.25468 2.66683 7.83334C2.66683 10.4113 4.75483 12.5 7.3335 12.5C8.54712 12.5019 9.71342 12.0294 10.5835 11.1833L10.6835 11.0833Z",
    fill: "#1D2C34"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f734e6e204889425c073c842cbe0d164.svg";
export { ForwardRef as ReactComponent };